import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';

var OptGroup = function (_React$Component) {
  _inherits(OptGroup, _React$Component);

  function OptGroup() {
    _classCallCheck(this, OptGroup);

    return _possibleConstructorReturn(this, (OptGroup.__proto__ || Object.getPrototypeOf(OptGroup)).apply(this, arguments));
  }

  return OptGroup;
}(React.Component);

OptGroup.isSelectOptGroup = true;
export default OptGroup;


//////////////////
// WEBPACK FOOTER
// ./~/rc-select/es/OptGroup.js
// module id = 1129
// module chunks = 0